// Cache identity is established by authenticated application state, never by a
// filename, bearer token or an identity left in browser storage by a prior login.
let scope = null;
let currentUserId = null;
let generation = 0;
const listeners = new Set();

export function getPrivateCacheScope() { return { scope, generation }; }
export function isCurrentPrivateCacheScope(snapshot) {
  return snapshot.generation === generation && snapshot.scope === scope;
}
export function setPrivateCacheScope(userId, tenantId) {
  currentUserId = userId || null;
  const next = userId && tenantId ? encodeURIComponent(JSON.stringify([String(userId), String(tenantId)])) : null;
  if (next === scope) return;
  scope = next;
  generation++;
  for (const listener of listeners) listener(getPrivateCacheScope());
}
export function clearPrivateCacheScope() { setPrivateCacheScope(null, null); }
export function subscribePrivateCacheScope(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function updatePrivateCacheTenant(tenantId) { setPrivateCacheScope(currentUserId, tenantId); }
